export default {
  methods: {
    searchForLocation: function (cityTitle, provinceTitle) {
      let city = cityTitle.toString();
      let province = provinceTitle.toString();
      this.$store.dispatch('searchForCityLocation', { city: city, county: province }).then(() => {
        if (this.$store.state.serviceModule.successFlag) {
          let temp = this.$store.state.serviceModule.locations;
          if (this.$route.name === 'hospital') {
            this.goToCity(temp);
          }
          if (this.$route.name === 'station') {
            this.goToCity(temp);
          }
          if (this.formLoad) {
            this.goToCityFromCity(temp);
          }
          if (this.deploymentFormLoad) {
            this.goToCityFromCity(temp);
          }
        } else {
          if (this.$store.state.serviceModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.searchForLocation(cityTitle, provinceTitle);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.serviceModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.searchForLocation(cityTitle, provinceTitle);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            // TODO this function has been disabled because mr.saneei said that
            // this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.serviceModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
